module.exports = __webpack_public_path__ + "static/media/rgs_plus_tablet.abc90223.png";